import React from 'react';
import PropTypes from 'prop-types';
import Loading from '@justgiving/loading';
import FormError from 'components/Alert/FormError';

const propTypes = {
  isLoading: PropTypes.bool.isRequired,
  error: PropTypes.bool,
  pastDelay: PropTypes.bool,
};

const defaultProps = {
  error: false,
  pastDelay: undefined,
};

const AsyncLoading = ({ isLoading, error, pastDelay }) => {
  if (isLoading) {
    return pastDelay ? <Loading /> : null;
  } else if (error) {
    return <FormError error />;
  }

  return null;
};

AsyncLoading.propTypes = propTypes;
AsyncLoading.defaultProps = defaultProps;

export default AsyncLoading;
